// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FMqN","option":"styles_option__3SlGA","active":"styles_active__3F7tR"};